module.exports = __webpack_public_path__ + "static/img/mobil-arrow.1842bd99.svg";